import { useState } from "react";

import { Checkbox, FormControlLabel, Stack, Typography } from "@mui/material";

import ConfirmationModal, {
  ConfirmationModalProps,
} from "@rui/ConfirmationModal";

type ConfirmationModalPropsPick = Pick<
  ConfirmationModalProps,
  "loading" | "open" | "onClose" | "onConfirm" | "confirmProps"
>;

interface AddWorkspaceMemberConfirmModalProps
  extends ConfirmationModalPropsPick {
  email: string;
  setSendNewTeamMemberInvites: (sendNewTeamMemberInvites: boolean) => void;
}

const AddWorkspaceMemberConfirmModal = ({
  onConfirm,
  setSendNewTeamMemberInvites,
  email,
  ...modalProps
}: AddWorkspaceMemberConfirmModalProps) => {
  const [skipSendInviteModal, setSkipSendInviteModal] =
    useState<boolean>(false);

  const handleSubmit = () => {
    if (skipSendInviteModal) {
      setSendNewTeamMemberInvites(true);
    }

    onConfirm();
  };

  return (
    <ConfirmationModal
      {...modalProps}
      onConfirm={handleSubmit}
      title="Are you sure?"
    >
      <Stack>
        <Typography variant="bodyPrimaryReg">
          You are about to send an invitation to{" "}
          <span style={{ fontWeight: 500 }}>{email}</span>. If they accept, they
          will join this Workspace and also be added to this team as a user.
        </Typography>
        <FormControlLabel
          control={
            <Checkbox
              checked={skipSendInviteModal}
              onClick={() => setSkipSendInviteModal(!skipSendInviteModal)}
            />
          }
          label="Don't ask me again"
        />
      </Stack>
    </ConfirmationModal>
  );
};

export default AddWorkspaceMemberConfirmModal;
